/**
 * 慣性スクロール
 */

import LocomotiveScroll from "locomotive-scroll";

export const scroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  //smooth: true,
  //smooth: location.search.search('smooth=false') === -1,
  smooth: false,
  //multiplier: 2,
  scrollFromAnywhere: true,
  resetNativeScroll: false,
  offset: [0, 0],
});

window.addEventListener("load", function () {
  scroll.update();

  // 初期スクロール
  if (window.location.hash) {
    // mmm...
    if (location.pathname == "/pages/shopping-guide" && 0 < location.hash.length) {
      return;
    }
    try {
      const target = document.querySelector(window.location.hash);
      if (target) {
        // ブラウザデフォルトのスクロールを初期化
        window.scrollTo(0, 0);
        document.body.scrollTo(0, 0);

        // 対象までスクロール
        const offset = document.querySelector(".site-header").getBoundingClientRect().height;
        scroll.scrollTo(target, { offset: -offset, duration: 100 });
        scroll.update();
      }
    } catch (e) {
      return;
    }
  }
});

setTimeout(function () {
  scroll.update();

  setInterval(function () {
    scroll.update();
  }, 10000);
}, 3000);
